module.exports = __webpack_public_path__ + "static/media/23_Bild_3_BCI_Team_Brain-Tweakers_NicolaPitaro_7881.40502afd.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle23/23_Bild_3_BCI_Team_Brain-Tweakers_NicolaPitaro_7881.jpg
 ** module id = 167
 ** module chunks = 0
 **/